import { PremiumFeature } from 'gleblu-socket-api';

import { Price } from '../models/interfaces/Price';
import {
  activeSubscriptionStatuses,
  Subscription,
  SubscriptionState,
  terminatedSubscriptionStatuses,
  undeterminedSubscriptionStatuses,
} from '../models/interfaces/Subscriptions';

export function renderPrice(price: Price, locale: string): string {
  const amount = price.unitAmount / 100;
  return Intl.NumberFormat(locale, { style: 'currency', currency: price.currency }).format(amount);
}

export function getSubscriptionKey(placeUuid: string, feature: PremiumFeature): string {
  return `${placeUuid}_${feature}`;
}

export const getPriceKey = getSubscriptionKey;

export function findSubscriptionState(subscriptions: Subscription[]): SubscriptionState | undefined {
  if (subscriptions.length === 0) return;
  if (subscriptions.find((subscription) => activeSubscriptionStatuses.includes(subscription.status))) return SubscriptionState.ACTIVE;
  if (subscriptions.find((subscription) => undeterminedSubscriptionStatuses.includes(subscription.status))) return SubscriptionState.UNDETERMINED;
  if (subscriptions.find((subscription) => terminatedSubscriptionStatuses.includes(subscription.status))) return SubscriptionState.TERMINATED;
  throw new Error(`Cannot determine subscription state`);
}

export function getSubscriptionState(subscriptions: Subscription[]): SubscriptionState {
  const state = findSubscriptionState(subscriptions);
  if (state === undefined) throw new Error('Cannot determine subscription state as there are no subscriptions');
  return state;
}

export function getSubscriptionWithState(state: SubscriptionState, subscriptions: Subscription[]): Subscription {
  switch (state) {
    case SubscriptionState.ACTIVE: {
      const subscription = subscriptions.find((subscription) => activeSubscriptionStatuses.includes(subscription.status));
      if (subscription === undefined) throw new Error(`Cannot find active subscription`);
      return subscription;
    }
    case SubscriptionState.UNDETERMINED: {
      const subscription = subscriptions.find((subscription) => undeterminedSubscriptionStatuses.includes(subscription.status));
      if (subscription === undefined) throw new Error(`Cannot find undetermined subscription`);
      return subscription;
    }
    default: {
      const subscription = subscriptions.find((subscription) => terminatedSubscriptionStatuses.includes(subscription.status));
      if (subscription === undefined) throw new Error(`Cannot find terminated subscription`);
      return subscription;
    }
  }
}

export function findSubscriptionWithState(state: SubscriptionState, subscriptions: Subscription[]): Subscription | undefined {
  switch (state) {
    case SubscriptionState.ACTIVE: {
      return subscriptions.find((subscription) => activeSubscriptionStatuses.includes(subscription.status));
    }
    case SubscriptionState.UNDETERMINED: {
      return subscriptions.find((subscription) => undeterminedSubscriptionStatuses.includes(subscription.status));
    }
    default: {
      return subscriptions.find((subscription) => terminatedSubscriptionStatuses.includes(subscription.status));
    }
  }
}
